import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { notifyError, notifySuccess } from "./notification.slice";
import { authFailCheck } from "./auth.slice";
import UserService from "./../services/UserService";

const usersAdapter = createEntityAdapter({
  selectId: (entryType) => entryType.id,
});

const usersSlice = createSlice({
  name: "users",
  initialState: usersAdapter.getInitialState({
    isLoading: false,
  }),
  reducers: {
    fetchRequest(state) {
      state.isLoading = true;
    },
    fetchFail(state, action) {
      state.isLoading = false;
    },
    fetchUsersSuccess(state, action) {
      state.isLoading = false;
      usersAdapter.setAll(state, action.payload);
    },
    updateUserSuccess(state, action) {
      state.isLoading = false;
      usersAdapter.upsertOne(state, action.payload);
    },
    createUserSuccess(state, action) {
      state.isLoading = false;
      usersAdapter.addOne(state, action.payload);
    },
    deleteUserSuccess(state, action) {
      state.isLoading = false;
      usersAdapter.removeOne(state, action.payload);
    },
  },
});

export const {
  fetchRequest,
  fetchFail,
  fetchUsersSuccess,
  updateUserSuccess,
  createUserSuccess,
  deleteUserSuccess,
} = usersSlice.actions;

export const usersSelectors = usersAdapter.getSelectors((state) => state.users);

export default usersSlice.reducer;

export const fetchUsers = () => async (dispatch) => {
  dispatch(fetchRequest());
  const response = await UserService.get();
  if (response.ok) {
    dispatch(fetchUsersSuccess(response.data));
  } else {
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};

export const updateUser = (userId, user) => async (dispatch) => {
  dispatch(fetchRequest());

  const response = await UserService.update(userId, user);

  if (response.ok) {
    dispatch(notifySuccess(`${user.name} o'zgartirildi.`));
    dispatch(updateUserSuccess({ id: userId, ...user }));
  } else {
    dispatch(authFailCheck(response));
    dispatch(
      notifyError(
        `${user.name}ni o'zgartirishda xatolik: ${response.data.errors[0]}`
      )
    );
    dispatch(fetchFail(response.data));
  }
};

export const createUser = (user) => async (dispatch) => {
  dispatch(fetchRequest());

  const response = await UserService.create(user);

  if (response.ok) {
    const { id } = response.data;
    dispatch(createUserSuccess({ id, ...user }));
    dispatch(notifySuccess(`${user.name} uchun profil yaratildi.`));
  } else {
    dispatch(authFailCheck(response));
    dispatch(
      notifyError(
        `${user.name} uchun profil yaratishda xatolik.: ${response.data}`
      )
    );
    dispatch(fetchFail(response.data));
  }
};

export const deleteUser = (userId) => async (dispatch, getState) => {
  dispatch(fetchRequest());
  const currentUser = usersSelectors.selectById(getState(), userId);
  const response = await UserService.delete(userId);
  if (response.ok) {
    dispatch(deleteUserSuccess(userId));
    dispatch(notifySuccess(`${currentUser.name} profili o'chirildi.`));
  } else {
    dispatch(authFailCheck(response));
    dispatch(
      notifyError(
        `${currentUser.name}ni o'chirishda xatolik.: ${response.data}`
      )
    );
    dispatch(fetchFail(response.data));
  }
};
